import React from "react";
import Navbar from "../Components/Navbar";
import Footer from "../Components/Footer";
import ProjPicAlhajaEstate from "../Components/ProjPicAlhajaEstate";

const ProjectPageAlhajaEstate = () => {
    return (
        <>
            <Navbar />
            <ProjPicAlhajaEstate />
            <Footer />
        </>
    );
};

export default ProjectPageAlhajaEstate;
